import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

/**
 * Lightweight hook that polls the visitor's active ticket.
 * Returns null when none (or when not logged in as client), otherwise
 * the ticket object with position, status, etc.
 */
export function useActiveTicket(intervalMs = 5000) {
  const { role } = useAuth();
  const [ticket, setTicket] = useState(null);

  useEffect(() => {
    let active = true;
    const load = async () => {
      if (role !== "client") { setTicket(null); return; }
      try {
        const { data } = await api.get("/tickets/my-active");
        if (active) setTicket(data);
      } catch {
        if (active) setTicket(null);
      }
    };
    load();
    const t = setInterval(load, intervalMs);
    return () => { active = false; clearInterval(t); };
  }, [role, intervalMs]);

  return ticket;
}
